const base = {
  color: 'neutral.foreground',
  fontFamily: 'default',
  margin: '0',
}

export const Display1 = {
  ...base,
  fontSize: '5xl',
  fontWeight: 'bold',
  lineHeight: '4xl',
}

export const Display2 = {
  ...base,
  fontSize: '4xl',
  fontWeight: 'bold',
  lineHeight: '3xl',
}

export const H1 = {
  ...base,
  fontSize: '3xl',
  fontWeight: 'bold',
  lineHeight: '2xl',
}

export const H2 = {
  ...base,
  fontSize: '2xl',
  fontWeight: 'bold',
  lineHeight: 'xl',
}

export const H3 = {
  ...base,
  fontSize: 'xl',
  fontWeight: 'bold',
  lineHeight: 'lg',
}

export const H4 = {
  ...base,
  fontSize: 'lg',
  fontWeight: 'bold',
  lineHeight: 'md',
}

export const Body1 = {
  ...base,
  fontSize: 'md',
  fontWeight: 'regular',
  lineHeight: 'md',
}

export const Body2 = {
  ...base,
  fontSize: 'sm',
  fontWeight: 'regular',
  lineHeight: 'md',
}

export const Caption = {
  ...base,
  fontSize: 'xs',
  fontWeight: 'regular',
  lineHeight: 'sm',
}
